<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <!-- <a class="logo" href="#" (click)="navigateHome()">S-<span>buddy</span></a> -->
    <img class="logo title_logo" src="assets/images/SBHeader.png" alt="logo" />
  </div>
  <!-- <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
    <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
  </nb-select> -->
</div>

<!-- <div class="header-container">
  <nb-actions size="small"> -->

    <!-- <nb-action class="control-item">
      <nb-search type="rotate-layout"></nb-search>
    </nb-action> -->
    <!-- <nb-action class="control-item" icon="email-outline"></nb-action>
    <nb-action class="control-item" icon="bell-outline"></nb-action>
    <nb-action class="user-action" *nbIsGranted="['view', 'user']" >
      <nb-user [nbContextMenu]="userMenu"
               [onlyPicture]="userPictureOnly"
               [name]="user?.name"
               [picture]="user?.picture"
               (menuClick)="onMenuItemClick($event)">>
      </nb-user>
    </nb-action>
  </nb-actions>
</div> -->
<div class="header-container">
  <nb-actions size="small">
    <!-- <nb-action class="control-item" icon="email-outline"></nb-action> -->
    <nb-action class="control-item" icon="bell-outline"></nb-action>
     <nb-action
      class="control-item"
      icon="question-mark-circle-outline"
      title="Help"
      (click)="openHelpLink()">
    </nb-action>
    <nb-action class="user-action" *nbIsGranted="['view', 'user']">
      <nb-user
        [onlyPicture]="userPictureOnly"
        [name]="user?.name"
        [picture]="user?.picture"
        [nbContextMenu]="userMenu"
        (nbContextMenuClick)="onMenuItemClick($event)">
      </nb-user>
    </nb-action>
    
    <nb-action class="control-item" icon="log-out-outline" (click)="logout()" title="Log out"></nb-action>
  </nb-actions>
</div>
